import { ITlfActionSetSubscriptionStatus, TlfContextProps } from "./interface";

/**
 * Updates the subscription flag for the current user and TLF item.
 *
 * @param state - Current TLF context state.
 * @param action - Set-subscription action containing the next subscription flag.
 * @returns Updated state with the subscription flag changed.
 */
export const tlf_setTlfSubscriptionStatus = (
  state: TlfContextProps,
  action: ITlfActionSetSubscriptionStatus,
): TlfContextProps => ({
  ...state,
  isSubscribed: action.isSubscribed,
});
